import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AffiliateService} from '../affiliate.service';
import {Constants} from '../../../shared/utils/constants';
import {AppService} from '../../../app.service';
import {Router} from '@angular/router';
import {Permission} from '../../../models/permission.model';

@Component({
  selector: 'fx-create-link',
  templateUrl: './create-link.component.html',
  styleUrls: ['./create-link.component.sass']
})
export class CreateLinkComponent implements OnInit {
  @ViewChild('formMam') formMam: NgForm;
  @ViewChild('formIB') formIB: NgForm;
  user: any = {};
  ib: any = {};
  listConfigTrader = [];
  listConfig = [];
  permission: Permission;
  constructor(
    private service: AffiliateService,
    private appService: AppService,
    private router: Router
  ) {
    this.getListGroupConfig();
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
  }

  private getListGroupConfig(): void {
    this.service.getGroupConfigs({})
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.listConfig = res.data;
          this.listConfigTrader = res.data;
            //.filter((f: any) => (f.name.indexOf('IB') < 0));
        }
      });
  }
  onChangeConfigTrade(): void {
    const group = this.listConfig.find(v => v.id === this.user.group) || null;
    if (group) {
      this.user.pip = group.data.pip;
      this.user.commission = group.data.commission;
    }
  }
  trimStart(event){
    event.target.value = event?.target?.value.trimStart();
  }

  selectedAllGroup(event){
    event ? this.ib.ibgroup = this.listConfig.filter((f)=> f.is_organic_ib === 1).map((x)=> x.id) : this.ib.ibgroup = [];
  }
  onCreateUser(): void {
    if (this.formMam.valid) {
     const body = {
       type: 0,
       description: this.user.linkname,
       data: {
         group_config_id: this.user.group
       }
     }
     this.service.createTradeCampaign(body)
       .subscribe(res => {
         if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
           this.appService.showSuccess('Create trade campaign success');
           this.formMam.onReset();
           this.router.navigate(['/app/affiliate/list']);
         } else {
           this.appService.showError('Create fail');
         }
       });
    }
  }
  onCreateIB(): void {
    if (this.formIB.valid) {
      const body = {
        type: this.ib.type ? 1 : 0,
        description: this.ib.link?.trim(),
        data: {
          group_config_id: this.ib.ibgroup,
          // commission: this.ib.commission / 100,
          // pip: this.ib.pip,
          // rate: this.ib.rate / 100
        }
      }
      this.service.createIBCampaign(body)
        .subscribe(res => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.appService.showSuccess('Create IB campaign success');
            this.formIB.onReset();
            this.router.navigate(['/app/affiliate/list']);
          } else {
            this.appService.showError('Create fail');
          }
        });
    }
  }

}
